import { render, staticRenderFns } from "./BIRReports.vue?vue&type=template&id=727e83c0"
import script from "./BIRReports.vue?vue&type=script&lang=js"
export * from "./BIRReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports